import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  ControlledVocabulary,
  ControlledVocabularyControllerService,
  EntityModelControlledVocabulary,
  PagedModelEntityModelControlledVocabulary
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-admin-controlledvocabularies",
  templateUrl: "./admin-controlledvocabularies.component.html",
  styleUrls: ["./admin-controlledvocabularies.component.css"],
  standalone: true,
  imports: [CrudTableComponent, FormsModule]
})
export class AdminControlledVocabularyComponent implements OnInit {
  private controller = inject(ControlledVocabularyControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[] = [];
  filterFields: string[] = [];
  crudAdapter:
    | CrudAdapter<
        PagedModelEntityModelControlledVocabulary,
        ControlledVocabulary
      >
    | undefined;

  ngOnInit() {
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "transactionUuid",
        header: "Transaction",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "label",
        header: "Label",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "name",
        header: "Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "version",
        header: "Version",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "uri",
        header: "Uri",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "visibility",
        header: "Visibility",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new ControlledVocabularyCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }
}
class ControlledVocabularyCrudAdapter extends CrudAdapter<
  PagedModelEntityModelControlledVocabulary,
  EntityModelControlledVocabulary
> {
  constructor(
    private controller: ControlledVocabularyControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelControlledVocabulary> {
    return this.controller.controlledVocabularyGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelControlledVocabulary[] {
    return <EntityModelControlledVocabulary[]>(
      entries?._embedded?.controlledVocabularies
    );
  }

  saveSingle(
    entity: EntityModelControlledVocabulary,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelControlledVocabulary> {
    return this.controller.controlledVocabularySaveSingle(
      <ControlledVocabulary>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.controlledVocabularyDeleteById(id, observe, reportProgress, options);
  }
}
